import { z } from 'zod';

const objectIdString = z.string().regex(/^[0-9a-fA-F]{24}$/, 'Geçersiz kimlik');

export const LinkMeasureEvaluationIdsSchema = z.object({
    ids: z.array(objectIdString).min(1, 'En az bir kayıt seçilmelidir'),
});

export const BulkUnlinkMeasureEvaluationIdsSchema = z.object({
    ids: z.array(objectIdString).min(1, 'En az bir kayıt seçilmelidir'),
});
